import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { updateCertification } from '../../actions/certificationActions'
import { isPublishable, showGenericError } from '../../utility/certificationBuilder'
import Toggle from '../common/form/Toggle'

import classes from './BuilderStatus.module.scss'

const REFRESH_INTERVAL = 30000

const BuilderStatus = ({ certification, lastSavedAt }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [isSaving, setIsSaving] = useState(false)
  const [, setTick] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => setTick(tick => tick + 1), REFRESH_INTERVAL)

    return () => clearInterval(timer)
  }, [])

  const blocked = !certification.published && !isPublishable(certification)

  const togglePublished = () => {
    setIsSaving(true)
    dispatch(updateCertification({ id: certification.id, published: !certification.published })).unwrap()
      .catch(showGenericError)
      .finally(() => setIsSaving(false))
  }

  return (
    <div className='d-flex align-items-center pull-right mr-2'>
      <span className={classNames('d-flex align-items-center', classes.status)}>
        <span className={classNames(classes.dot, { [classes.dotPublished]: certification.published })} />
        {t(certification.published ? 'certificationBuilder.page.published' : 'certificationBuilder.page.draft')}
        {lastSavedAt && <span className={classes.saved}> · {t('certificationBuilder.page.saved', { time: moment(lastSavedAt).fromNow() })}</span>}
      </span>
      <label
        className={classNames('d-flex align-items-center mb-0', classes.toggle)}
        title={blocked ? t('certificationBuilder.page.publishBlocked') : undefined}
      >
        <Toggle size='small' checked={certification.published} onChange={togglePublished} disabled={isSaving || blocked} />
        {t('certificationBuilder.page.published')}
      </label>
    </div>
  )
}

BuilderStatus.propTypes = {
  certification: PropTypes.shape({
    id: PropTypes.number.isRequired,
    published: PropTypes.bool.isRequired,
  }).isRequired,
  lastSavedAt: PropTypes.string,
}

export default BuilderStatus
